import React, { useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import Avatar from '../Global/Avatar';
import Mauricio from '../../assets/img/mauricio@2x.png';
import transcompiler from '../../core/transcompiler';
import { OptionContext } from '../../contexts/OptionContext';

const nextDefault = () => { };

const StyleCustom = styled.div`${
  (props) => css`
    color: ${props.foreground};
  `
}`;

const UserText = ({ message = '', next = nextDefault, data = [] }) => {
  const context = useContext(OptionContext);
  const { dialog } = context;

  useEffect(() => {
    setTimeout(next, 2000);
  }, []);

  return (
    <Container className="py-2 mr-3 pr-3">
      <Row className="mt-4" style={{
        minHeight: '50px',
      }}
      >
        <Col xs="10" className="ml-auto">
          <Row>
            <Col xs="auto" className="ml-auto">
              <StyleCustom foreground={dialog.foreground} className="dialog-typo">
                {transcompiler(message, data)}
              </StyleCustom>
            </Col>
          </Row>
        </Col>
        <Avatar
          rounded
          size="sm"
          src={dialog.userAvatar}
        />
      </Row>
    </Container>
  );
};

export default UserText;
